<script>
  import { cart, stage, Stages, formdata, deliveryServices, paymentServices, lockerPoint, formStorageKey, lockerPointStorageKey, withLocalePrefix, cartStorageKey } from './storage.js';
  import { updateCart, handleResponse } from './requests.js';
  import Loader from '../components/Loader.svelte';
  import Money from './Money.svelte';
  import OrderItem from './OrderItem.svelte';
  import FormField from '@smui/form-field';
  import Checkbox from '@smui/checkbox';

  let loading = $state(false);
  let privacy_policy = $state(false);
  let regulations = $state(false);
  let placementErrors = $state([]);
  let attemptCount = $state(0);

  const finalize = () => {
    if (!regulations || !privacy_policy) {
      attemptCount++;
      return;
    }
    loading = true;
    placementErrors = [];

    const payload = {
      ...$formdata,
      token: $cart.token,
      status: 'placed',
      privacy_policy,
      regulations,
    };

    if ($cart.no_delivery) {
      payload.payment_on_delivery = false;
    } else {
      payload.payment_on_delivery = $cart.payment_on_delivery;
      payload.delivery_service_id = $cart.delivery_service_id;

      if ($lockerPoint) {
        payload.pickup_point_name    = $lockerPoint.name;
        payload.pickup_point_address = $lockerPoint.address;
      }
    }
    
    updateCart($cart.id, payload)
    .then(handleResponse)
    .then(response => {
      clearLocalStorage();
      location.href = withLocalePrefix(`/summary/${response.data.token}`);
    })
    .catch((error) => {
      loading = false;
      try {
        const {status, ...data} = JSON.parse(error.message);
        const fieldLabels = {
          email: 'Adres e-mail', phone: 'Telefon',
          billing_address_attributes: 'Adres rozliczeniowy',
          delivery_address_attributes: 'Adres dostawy',
          delivery_service_id: 'Metoda dostawy',
          regulations: 'Regulamin', privacy_policy: 'Polityka prywatności',
        };
        placementErrors = Object.entries(data).map(([field, codes]) => {
          const label = fieldLabels[field] || field;
          const msgs = Array.isArray(codes) ? codes : [codes];
          return `${label}: ${msgs.join(', ')}`;
        });
      } catch {
        placementErrors = ['General error: ' + error.message];
      }
    })
  };

  const clearLocalStorage = () => {
    localStorage.removeItem('cart');
    localStorage.removeItem(cartStorageKey);
    localStorage.removeItem(formStorageKey($cart.token));
    localStorage.removeItem(lockerPointStorageKey($cart.token));
  }

  let selectedMethod = $derived(($deliveryServices ? $deliveryServices : []).find(item => item['id'] === $cart.delivery_service_id));
</script>


<h1>Podsumowanie</h1>

<div class="row row-m1">
  <div class="box condensed">
    <p>
      <span class="bolder">Dane kontaktowe</span><br>
      <span class="smaller">
        {$formdata.email}
        {#if $formdata.phone}
          <br>{$formdata.phone}
        {/if}
      </span>
    </p>

    <p>
      <span class="bolder">Adres rozliczeniowy</span><br>
      <span class="smaller">
        {#if $formdata.billing_address_attributes.b2b}
          {$formdata.billing_address_attributes.company_name}, NIP {$formdata.tax_id}
          {#if $formdata.billing_address_attributes.first_name || $formdata.billing_address_attributes.last_name}<br>{/if}
        {/if}
        {$formdata.billing_address_attributes.first_name || ''} {$formdata.billing_address_attributes.last_name || ''}<br>
        {$formdata.billing_address_attributes.street} {$formdata.billing_address_attributes.building} {$formdata.billing_address_attributes.apartment || ''}<br>
        {$formdata.billing_address_attributes.zipcode} {$formdata.billing_address_attributes.city}
      </span>
    </p>

    {#if $formdata.comment}
      <p>
        <span class="bolder">Uwagi do zamówienia</span><br>
        <span class="smaller" style="white-space: pre-line">{$formdata.comment}</span>
      </p>
    {/if}
  </div>

  <div class="box condensed">
    <p>
      <span class="bolder">Dostawa</span><br>
      <span class="smaller">
        {#if $cart.no_delivery}
          E-mail
        {:else if selectedMethod}
          {selectedMethod.name} ({$cart.delivery_price_with_currency})
        {/if}
      </span>
    </p>
    <p>
      {#if $lockerPoint}
        <span class="bolder">Paczkomat</span><br>
        <span class="smaller">{$lockerPoint.name} – {$lockerPoint.address}</span>
      {:else if $formdata.delivery_address_attributes}
        <span class="bolder">Adres dostawy</span><br>
        <span class="smaller">
          {$formdata.delivery_address_attributes.first_name} {$formdata.delivery_address_attributes.last_name}<br>
          {$formdata.delivery_address_attributes.street} {$formdata.delivery_address_attributes.building} {$formdata.delivery_address_attributes.apartment || ''}<br>
          {$formdata.delivery_address_attributes.zipcode} {$formdata.delivery_address_attributes.city}
        </span>
      {:else if !$cart.no_delivery}
        <span class="bolder">Dostawa pod ten sam adres.</span>
      {/if}
    </p>

    <p>
      
      {#if $cart.payment_on_delivery}
        <span class="bolder">Płatność przy odbiorze.</span>
      {:else}
        <span class="bolder">Płatność z góry</span><br>
        <span class="smaller">
          Dostępne formy płatności:
          {#if $paymentServices}
            { $paymentServices.map(item => item.name).join(', ') }.
          {/if}
        </span>
      {/if}
    </p>
  </div>
</div>

<div class="box">
  {#each $cart.order_items as item}
    <OrderItem {item} />
  {/each}
</div>

<Money />

{#key attemptCount}
<div class="row row-1" class:acceptance-required={attemptCount > 0 && !regulations} style="margin-top: 20px;">
    <FormField>
      <Checkbox class="acceptance_regulations" bind:checked={regulations}  />
      {#snippet label()}
        Akceptuję <a href="/regulamin" target="_blank">regulamin</a> sklepu internetowego.
      {/snippet}
    </FormField>
  </div>
  <div class="row row-1" class:acceptance-required={attemptCount > 0 && !privacy_policy}>
    <FormField>
      <Checkbox class="acceptance_privacy_policy" bind:checked={privacy_policy} />
      {#snippet label()}
        Zapoznałem/am się z <a href="/polityka-prywatnosci" target="_blank">polityką prywatności</a> sklepu internetowego.
      {/snippet}
    </FormField>
  </div>
{/key}

{#if placementErrors.length}
  <div class="placement-errors">
    Wystąpiły błędy podczas składania zamówienia:
    <ul>
      {#each placementErrors as err}<li>{err}</li>{/each}
    </ul>
  </div>
{/if}

<div class="actions">
  <div class="actions-left">
    <!-- svelte-ignore a11y_missing_attribute -->
    <a class="promocode__trigger" role="button" tabindex="0" onclick={() => $stage = Stages.FORM} onkeydown={(e) => e.key === 'Enter' && ($stage = Stages.FORM)}>‹ Zmieniam dane</a>
  </div>
  <div class="actions-right">
    {#if loading}
      <Loader />
    {:else}
      <button class="button" class:button--pending={!regulations || !privacy_policy} onclick={finalize}>Zamawiam i płacę</button>
    {/if}
  </div>
</div>


<style>
  .box {
    border: 1px solid #e0e0e0;
    margin-bottom: 15px;
    padding: 20px 25px;
  }

  .box p:last-of-type {
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .placement-errors {
    border: 1px solid #c0392b;
    border-radius: 3px;
    color: #c0392b;
    font-size: 0.9em;
    margin-bottom: 15px;
    padding: 10px 15px;
  }

  .placement-errors ul {
    margin: 6px 0 0;
    padding-left: 18px;
  }

  .placement-errors p {
    margin: 0;
  }

  .placement-errors p + p {
    margin-top: 4px;
  }

  @media (max-width: 767px) {
    .box {
      margin-bottom: 10px;
      padding: 10px;
    }
  }

  .acceptance-required {
    color: #c0392b;
    border-left: 3px solid #c0392b;
    padding-left: 8px;
    border-radius: 2px;
    background-color: rgba(192, 57, 43, 0.06);
    animation: shake-acceptance 0.35s ease;
  }

  @keyframes shake-acceptance {
    0%, 100% { transform: translateX(0); }
    25%       { transform: translateX(-5px); }
    75%       { transform: translateX(5px); }
  }

  button.button--pending {
    opacity: 0.55;
    cursor: default;
    filter: grayscale(25%);
  }
</style>
